import { createAction } from '@reduxjs/toolkit';

import { GenericPayloadType } from '@ezugi/types';

import { menuActions as menuActionsFromSlice } from '../reducers/menu';

type CashierRequestPayload = { source: string };

export const menuActions = {
  cashier: {
    request: createAction<CashierRequestPayload>('cashier/request'),
    success: createAction('cashier/success'),
    failure: createAction<GenericPayloadType>('cashier/failure'),
    set: createAction('cashier/set'),
  },
  home: {
    request: createAction('home/request'),
    success: createAction<GenericPayloadType>('home/success'),
    redirect: createAction('home/redirect'),
    failure: createAction<GenericPayloadType>('home/failure'),
    set: createAction('home/set'),
  },
  responsibleGaming: {
    request: createAction('responsibleGaming/request'),
    success: createAction('responsibleGaming/success'),
    failure: createAction<GenericPayloadType>('responsibleGaming/failure'),
  },
  menu: menuActionsFromSlice,
};
